"use strict";

exports.__esModule = true;
exports.default = void 0;
var _baseIsMap = _interopRequireDefault(require("./_baseIsMap.js"));
var _baseUnary = _interopRequireDefault(require("./_baseUnary.js"));
var _nodeUtil = _interopRequireDefault(require("./_nodeUtil.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* Node.js helper references. */
var nodeIsMap = _nodeUtil.default && _nodeUtil.default.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? (0, _baseUnary.default)(nodeIsMap) : _baseIsMap.default;
var _default = exports.default = isMap;